import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
    const location = useLocation();
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;
        const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
        const exchange = async () => {
            try {
                const res = await fetch(
                    `${process.env.REACT_APP_BACKEND_URL}/api/auth/session`,
                    {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        credentials: "include",
                        body: JSON.stringify({ session_id: sessionId }),
                    }
                );
                if (!res.ok) throw new Error("exchange failed");
                const user = await res.json();
                setUser(user);
                navigate(location.pathname || "/", { replace: true, state: { user } });
            } catch {
                navigate("/", { replace: true });
            }
        };
        exchange();
    }, [location, navigate, setUser]);

    return (
        <div
            data-testid="auth-callback"
            className="flex min-h-screen items-center justify-center bg-[#0A0A0A]"
        >
            <div className="h-8 w-8 animate-spin rounded-full border-2 border-amber-400 border-t-transparent" />
        </div>
    );
}
